export { default } from "./UpsellItems";
